import { DunsCompanyInfo } from "@/types";

export const transformCompanyData = (response: any): DunsCompanyInfo | null => {
  const candidate = response.searchCandidates?.[0];
  if (!candidate) return null;

  const org = candidate.organization;
  const address = org.primaryAddress;

  // Find the business registration number (not VAT)
  const businessRegNumber = org.registrationNumbers?.find((reg: any) =>
    reg.typeDescription?.includes("Register of Business")
  );

  return {
    name: org.primaryName,
    orgNumber: businessRegNumber?.registrationNumber || "",
    address: address.streetAddress.line1,
    city: address.addressLocality.name,
    region: address.addressRegion.name,
    postalCode: address.postalCode,
    country: address.addressCountry.name,
    countryCode: address.addressCountry.isoAlpha2Code,
    website: org.websiteAddress?.[0]?.url,
    employees: org.numberOfEmployees?.[0]?.value,
    duns: org.duns,
  };
};
